import { SectionProps } from '@comparaonline/ui-wizard-step-manager/dist/types';

const Car: SectionProps = {
  id: 'car-section',
  name: () => 'Vehículo'
};

const Confirmation: SectionProps = {
  id: 'confirmation-section',
  name: () => 'Confirmación'
};

const Payment: SectionProps = {
  id: 'payment-section',
  name: () => 'Medio de pago'
};

export { Car, Confirmation, Payment };
